// extracted by mini-css-extract-plugin
module.exports = {"bb":"bb__JHu1C","how-gifts-work":"how-gifts-work__fnmkl","how-gifts-work__item":"how-gifts-work__item__2iTPu"};